module.exports = __webpack_public_path__ + "assets/img/qrcode.eb961883.png";